import { Check } from "lucide-react"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"

const H = ({ children }) => (
  <h2 className="font-display text-3xl font-black text-brand-light">{children}</h2>
)

export function ProductExtras({ product }) {
  if (!product.benefits && !product.useCases && !product.included && !product.faqs) return null
  return (
    <section className="mx-auto grid max-w-7xl gap-8 px-6 pb-20 md:px-14 lg:grid-cols-2" data-testid="product-extras">
      {product.benefits && (
        <div className="rounded-3xl border border-brand-green/15 bg-brand-mid p-8" data-testid="product-benefits">
          <H>KEY BENEFITS</H>
          <ul className="mt-5 space-y-3">
            {product.benefits.map((b) => (
              <li key={b} className="flex gap-3 text-sm leading-relaxed text-brand-light/85">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-green-light" />{b}
              </li>
            ))}
          </ul>
        </div>
      )}
      {product.included && (
        <div className="rounded-3xl border border-brand-green/15 bg-brand-mid p-8" data-testid="product-included">
          <H>WHAT'S INCLUDED</H>
          <ul className="mt-5 space-y-3">
            {product.included.map((b) => (
              <li key={b} className="flex gap-3 text-sm leading-relaxed text-brand-light/85">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-green-light" />{b}
              </li>
            ))}
          </ul>
        </div>
      )}
      {product.useCases && (
        <div className="lg:col-span-2" data-testid="product-use-cases">
          <H>TYPICAL USE CASES</H>
          <div className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {product.useCases.map((u) => (
              <div key={u.title} className="rounded-2xl border border-brand-green/15 bg-brand-navy p-6 transition-colors hover:border-brand-green/50">
                <div className="font-bold text-brand-light">{u.title}</div>
                <p className="mt-2 text-sm leading-relaxed text-brand-muted">{u.text}</p>
              </div>
            ))}
          </div>
        </div>
      )}
      {product.faqs && (
        <div className="lg:col-span-2" data-testid="product-faqs">
          <H>FREQUENTLY ASKED QUESTIONS</H>
          <Accordion type="single" collapsible className="mt-4">
            {product.faqs.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="border-brand-green/15">
                <AccordionTrigger className="text-left text-brand-light hover:no-underline" data-testid={`product-faq-${i}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="text-brand-muted">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      )}
    </section>
  )
}
